import {
  getBackButtonRoute,
  getPreservedBackButtonParams,
  goToMySpaceNav,
} from '@core/constants/backButtonNavigation';

// Route used by the assignments sidebar back button. Honours the `from` chain
// (e.g. `from=home`) and falls back to the space navigation page.
export const getSpaceBackRoute = (spaceId?: string): string | null => {
  if (!spaceId) {
    return null;
  }

  return getBackButtonRoute() || goToMySpaceNav(spaceId);
};

export const getAssignmentsBaseRoute = (spaceId?: string) =>
  `/dashboard/${spaceId}/journey/assignments`;

// Assignment details route, preserving the current navigation origin so the
// details page keeps a working back button once the user returns to it.
export const getAssignmentDetailsRoute = (
  spaceId?: string,
  assignmentId?: string
) =>
  `${getAssignmentsBaseRoute(
    spaceId
  )}/${assignmentId}${getPreservedBackButtonParams()}`;
